import { useTranslation } from 'react-i18next';

/**
 * Hook personalizado que extiende useTranslation con funcionalidad de keyPrefix
 * @param {string} prefix - Prefijo que se añadirá automáticamente a todas las claves de traducción
 * @returns {object} Objeto con función "t" prefijada y resto de propiedades de useTranslation
 *
 * @example
 * // En lugar de: t('dashboard.userSection.accountInfo.accountType.label')
 * const {t} = useTranslationWithPrefix('dashboard.userSection.accountInfo');
 * const label = t('accountType.label'); // Resultado: traduce 'dashboard.userSection.accountInfo.accountType.label'
 */
const useTranslationWithPrefix = (prefix) => {
  const { t } = useTranslation();

  /**
   * Función de traducción con prefijo automático
   * @param {string} key - Clave de traducción (se añadirá automáticamente el prefijo)
   * @param {object} options - Opciones adicionales de i18next (interpolación, etc.)
   * @returns {string} Texto traducido
   */
  const tPrefixed = (key, options = {}) => {
    const fullKey = prefix ? `${prefix}.${key}` : key;
    return t(fullKey, options);
  };

  return { t: tPrefixed, tOriginal: t };
};

export default useTranslationWithPrefix;
